import React from 'react';
import { Chip } from '@mui/material';
import { ChipColor, ChipSize, ChipVariant } from './types';

interface SimpleChipProps {
     label: string;
     color?: ChipColor;
     size?: ChipSize;
     variant?: ChipVariant;
     sx?: any;
     customColor?: string;
}

export const SimpleChip: React.FC<SimpleChipProps> = ({
     label,
     color = 'default',
     size = 'small',
     variant = 'filled',
     sx,
     customColor
}) => (
     <Chip
          label={label}
          size={size}
          color={color}
          variant={variant}
          sx={{
               ...(customColor && {
                    backgroundColor: customColor,
                    color: 'white',
                    '&:hover': { backgroundColor: customColor },
               }),
               ...sx,
          }}
     />
);